import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5d1ee1d8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dates" }
const _hoisted_2 = { class: "content-cols" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col col-7" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Our virtual immersions are the anchor points for accountability, creativity, and community. At these meetings, you connect with like-minded people and gain inspiration. Each quarter you take stock around what worked last quarter, what didn't and what you want to do next.")
], -1 /* HOISTED */))
const _hoisted_4 = { class: "col col-3" }
const _hoisted_5 = { class: "vue-immersion-dates-component" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("h2", null, "Virtual Immersion Dates " + _toDisplayString(_ctx.upcomingImmersionDatesYears), 1 /* TEXT */),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("ul", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.upcomingImmersionDatesDisplay, (d) => {
            return (_openBlock(), _createElementBlock("li", { key: d }, _toDisplayString(d), 1 /* TEXT */))
          }), 128 /* KEYED_FRAGMENT */))
        ])
      ])
    ])
  ]))
}